import { RootState } from "integrations/redux/rootReducer"
import { AppGlobalNotificationContext, MapboxUserContext } from "./types"
import { AddOns } from "@nova/constants"

const root = (state: RootState) => state.application.user.profile

export const selectUserOrganization = (state: RootState): string | undefined =>
    root(state).organization

export const selectHasInitiallyFetchedMe = (state: RootState): boolean =>
    root(state).hasInitiallyFetchedMe
export const selectIsFetchingMe = (state: RootState): boolean => root(state).isFetchingMe

export const selectUserRegion = (state: RootState): string | undefined => root(state).region
export const selectUserID = (state: RootState): string | undefined => root(state).id
export const selectUserEmail = (state: RootState): string | undefined => root(state).email
export const selectMapboxContext = (state: RootState): MapboxUserContext => root(state).mapbox
export const selectUserProfilePhotoS3Key = (state: RootState): string | undefined =>
    root(state).profilePhotoS3Key
export const selectUserProfileDefaultWorkspaceId = (state: RootState): string | undefined =>
    root(state).defaultWorkspaceId

export const selectGlobalNotificationContext = (state: RootState): AppGlobalNotificationContext =>
    root(state).globalNotificationContext

export const selectUserLicense = (state: RootState) =>
    root(state).license || root(state).liteLicense!
export const selectUserAddOns = (state: RootState): Record<AddOns, boolean> => root(state).addOns

export const selectIsDomainWhiteListed = (state: RootState): boolean =>
    root(state).isDomainWhiteListed

export const selectUserGroups = (state: RootState): string[] | undefined => root(state).groups
